export const UPDATE_CHECKLIST = "UPDATE_CHECKLIST";
export const STEPPER = "STEPPER";
export const SELECTED_EMPLOYEES = "SELECTED_EMPLOYEES";
export const UNSELECTED_EMPLOYEES = "UNSELECTED_EMPLOYEES";
export const UPLOADED_EMPLOYEES = "UPLOADED_EMPLOYEES";
export const ACTIVE_TAB = "ACTIVE_TAB";
export const UPDATE_PAGE_IN_REDUX = "UPDATE_PAGE_IN_REDUX";
export const ACTIVE_SUB_TAB = "ACTIVE_SUB_TAB";
